const pad2 = value => String(value).padStart(2, "0");

export function plural(count) {
    return count !== 1 ? "s" : "";
}

export function formatReception(dateStr) {
    if (!dateStr) return { date: "—", time: "" };
    const d = new Date(dateStr);
    const date = `${pad2(d.getDate())}/${pad2(d.getMonth() + 1)}/${String(d.getFullYear()).slice(2)}`;
    const time = `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
    return { date, time };
}

function parseValidDate(dateStr) {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function receptionDayKey(dateStr) {
    const date = parseValidDate(dateStr);
    if (!date) return "sans-date";
    return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function formatDayHeading(dateStr) {
    const date = parseValidDate(dateStr);
    if (!date) return "DATE INCONNUE";

    const today = new Date();
    const startToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const dayDifference = Math.round((startToday - startDate) / 86_400_000);
    const calendarLabel = new Intl.DateTimeFormat("fr-FR", {
        weekday: "long",
        day: "numeric",
        month: "long",
        ...(date.getFullYear() !== today.getFullYear() ? { year: "numeric" } : {}),
    }).format(date).replace(/^./, character => character.toUpperCase());

    if (dayDifference === 0) return `Aujourd'hui · ${calendarLabel}`;
    if (dayDifference === 1) return `Hier · ${calendarLabel}`;
    return calendarLabel;
}

export function groupByReceptionDay(commandes) {
    const groups = [];
    const groupsByDay = new Map();
    commandes.forEach((cmd, idx) => {
        const key = receptionDayKey(cmd.dateReception);
        let group = groupsByDay.get(key);
        if (!group) {
            group = { key, dateReception: cmd.dateReception, items: [] };
            groupsByDay.set(key, group);
            groups.push(group);
        }
        group.items.push({ cmd, idx });
    });
    return groups;
}

export function patientDisplayName(patient) {
    const name = `${patient?.prenom || ""} ${patient?.nom || ""}`.trim();
    return name || "Patient non identifié";
}

export function attachmentCount(cmd) {
    return Math.max(
        cmd.files?.length ?? 0,
        cmd.fileNames?.length ?? 0,
        cmd.filePaths?.length ?? 0,
        cmd.ordonnanceIds?.length ?? 0,
    );
}

export function attachmentLabel(count) {
    return `${count} pièce${plural(count)} jointe${plural(count)}`;
}

export function destinationCounts(patients) {
    const medicines = patients.flatMap(patient => patient.medicaments ?? []);
    return {
        robot: medicines.filter(medicine => medicine.destination === "ROBOT").length,
        etiquetage: medicines.filter(medicine => medicine.destination === "ETIQUETAGE").length,
    };
}
